import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsContainer } from "@/features/app-settings/containers/settings-container";

function SettingsPageRoute() {
  return <AccountSettingsContainer />;
}

export const Route = createFileRoute("/app/settings")({
  component: SettingsPageRoute,
});
